"use strict";
// Resources
//  - https://betterstack.dev/blog/publishing-type-definitions-with-npm-package/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepaymentTape = exports.RepaymentEntry = exports.Receivable = exports.Railz = exports.PostgresQuery = exports.PortfolioGeneratedLoanTape = exports.PortfolioCovenant = exports.PipelineHelpers = exports.Pipeline = exports.Pdf = exports.OrgProvidedInputs = exports.Organization = exports.Notifications = exports.nodeEnvs = exports.MaterializedView = exports.MasterLoanTape = exports.Log = exports.LoanProduct = exports.LoanMechanics = exports.Loan = exports.LimitedPartners = exports.Invoice = exports.Insights = exports.IbsIntegration = exports.FundingRequest = exports.Funding = exports.FinStatementV2 = exports.FormulaEngine = exports.FinleyAi = exports.Explo = exports.Event = exports.Email = exports.Deliverable = exports.Date = exports.DataPipeline = exports.DataLake = exports.DataTapeField = exports.CustomerProvidedValues = exports.CreditFacility = exports.CreditAgreement = exports.CovenantLoanTape = exports.Cdq = exports.BorrowingBase = exports.Bank = exports.Assignment = exports.AssignedLoanTape = exports.AssetVerification = exports.Accounting = exports.FinancialData = exports.FinancialCovenant = void 0;
exports.typeguards = exports.schemas = exports.DbTable = exports.Util = exports.Reporting = exports.Report = void 0;
/**
 * NOTE: our type files must be .ts files (and not .d.ts files here)
 *
 * "Write type definitions in .ts files
 * The first thing we need to do is make sure our type definitions are inside .ts files, not .d.ts. This is because the TypeScript compiler will not emit another declaration file for existing .d.ts files. Neither will it fix your type import paths in the emitted declaration files to point to any types imported from your existing .d.ts files.
 * As such, some of your types won't be exported correctly.""
 * - https://betterstack.dev/blog/publishing-type-definitions-with-npm-package/
 */
const zod_1 = require("zod");
const typeguards = __importStar(require("./typeguards"));
exports.typeguards = typeguards;
const Accounting = __importStar(require("./types/Accounting"));
exports.Accounting = Accounting;
const AssetVerification = __importStar(require("./types/AssetVerification"));
exports.AssetVerification = AssetVerification;
const AssignedLoanTape = __importStar(require("./types/AssignedLoanTape"));
exports.AssignedLoanTape = AssignedLoanTape;
const Assignment = __importStar(require("./types/Assignment"));
exports.Assignment = Assignment;
const Bank = __importStar(require("./types/Bank"));
exports.Bank = Bank;
const BorrowingBase = __importStar(require("./types/BorrowingBase"));
exports.BorrowingBase = BorrowingBase;
const Cdq = __importStar(require("./types/Cdq"));
exports.Cdq = Cdq;
const CovenantLoanTape = __importStar(require("./types/CovenantLoanTape"));
exports.CovenantLoanTape = CovenantLoanTape;
const CreditAgreement = __importStar(require("./types/CreditAgreement"));
exports.CreditAgreement = CreditAgreement;
const CreditAgreement_1 = require("./types/CreditAgreement");
Object.defineProperty(exports, "DataTapeField", { enumerable: true, get: function () { return CreditAgreement_1.DataTapeField; } });
const CreditFacility = __importStar(require("./types/CreditFacility"));
exports.CreditFacility = CreditFacility;
const CustomerProvidedValues = __importStar(require("./types/CustomerProvideValues"));
exports.CustomerProvidedValues = CustomerProvidedValues;
const DataLake = __importStar(require("./types/DataLake"));
exports.DataLake = DataLake;
const DataPipeline = __importStar(require("./types/DataPipeline"));
exports.DataPipeline = DataPipeline;
const Date = __importStar(require("./types/Date"));
exports.Date = Date;
const DbTable = __importStar(require("./types/DbTables"));
exports.DbTable = DbTable;
const Deliverable = __importStar(require("./types/Deliverable"));
exports.Deliverable = Deliverable;
const Email = __importStar(require("./types/Email"));
exports.Email = Email;
const Event = __importStar(require("./types/Event"));
exports.Event = Event;
const Explo = __importStar(require("./types/Explo"));
exports.Explo = Explo;
const FinleyAi = __importStar(require("./types/FinleyAi"));
exports.FinleyAi = FinleyAi;
const FinStatementV2 = __importStar(require("./types/FinStatementsV2"));
exports.FinStatementV2 = FinStatementV2;
const FormulaEngine = __importStar(require("./types/FormulaEngine"));
exports.FormulaEngine = FormulaEngine;
const Funding = __importStar(require("./types/Funding"));
exports.Funding = Funding;
const FundingRequest = __importStar(require("./types/FundingRequest"));
exports.FundingRequest = FundingRequest;
const IbsIntegration = __importStar(require("./types/IbsIntegration"));
exports.IbsIntegration = IbsIntegration;
const Insights = __importStar(require("./types/Insights"));
exports.Insights = Insights;
const Invoice = __importStar(require("./types/Invoice"));
exports.Invoice = Invoice;
const LimitedPartners = __importStar(require("./types/LimitedPartners"));
exports.LimitedPartners = LimitedPartners;
const LoanMechanics = __importStar(require("./types/LoanMechanics"));
exports.LoanMechanics = LoanMechanics;
const LoanProduct = __importStar(require("./types/LoanProduct"));
exports.LoanProduct = LoanProduct;
const Loan = __importStar(require("./types/Loans"));
exports.Loan = Loan;
const Log = __importStar(require("./types/Log"));
exports.Log = Log;
const MasterLoanTape = __importStar(require("./types/MasterLoanTape"));
exports.MasterLoanTape = MasterLoanTape;
const MaterializedView = __importStar(require("./types/MaterializedView"));
exports.MaterializedView = MaterializedView;
const NodeEnv_1 = require("./types/NodeEnv");
Object.defineProperty(exports, "nodeEnvs", { enumerable: true, get: function () { return NodeEnv_1.nodeEnvs; } });
const Notifications = __importStar(require("./types/Notifications"));
exports.Notifications = Notifications;
const Organization = __importStar(require("./types/Organization"));
exports.Organization = Organization;
const OrgProvidedInputs = __importStar(require("./types/OrgProvidedInputs"));
exports.OrgProvidedInputs = OrgProvidedInputs;
const Pdf = __importStar(require("./types/Pdf"));
exports.Pdf = Pdf;
const Pipeline = __importStar(require("./types/Pipeline"));
exports.Pipeline = Pipeline;
const PipelineHelpers = __importStar(require("./types/PipelineHelpers"));
exports.PipelineHelpers = PipelineHelpers;
const PortfolioCovenant = __importStar(require("./types/PortfolioCovenant"));
exports.PortfolioCovenant = PortfolioCovenant;
const PortfolioGeneratedLoanTape = __importStar(require("./types/PortfolioGeneratedLoanTape"));
exports.PortfolioGeneratedLoanTape = PortfolioGeneratedLoanTape;
const PostgresQuery = __importStar(require("./types/PostgresQuery"));
exports.PostgresQuery = PostgresQuery;
const Railz = __importStar(require("./types/Railz"));
exports.Railz = Railz;
const Receivable = __importStar(require("./types/Receivable"));
exports.Receivable = Receivable;
const RepaymentEntry = __importStar(require("./types/RepaymentEntry"));
exports.RepaymentEntry = RepaymentEntry;
const RepaymentTape = __importStar(require("./types/RepaymentTape"));
exports.RepaymentTape = RepaymentTape;
const Report = __importStar(require("./types/Report"));
exports.Report = Report;
const Reporting = __importStar(require("./types/Reporting"));
exports.Reporting = Reporting;
const Util = __importStar(require("./types/Utils"));
exports.Util = Util;
exports.FinancialCovenant = __importStar(require("./types/FinancialCovenants"));
exports.FinancialData = __importStar(require("./types/FinancialData"));
// Currently limiting which schemas are exposed for intentionality.
// If needed / more beneficial to expose all, can update export pattern here
// NOTE: Using z.toJSONSchema (Zod 4) to generate JSON Schema from Zod schemas for Monaco editor compatibility
// Using draft-7 target for Monaco editor compatibility
const schemas = {
    ConcentrationLimitSourceConfigSchema: zod_1.z.toJSONSchema(CreditAgreement.Config.ConcentrationLimit.SourceConfigSchema, { target: 'draft-7' }),
};
exports.schemas = schemas;
//# sourceMappingURL=index.js.map